import { render, staticRenderFns } from "./averageDisplayModal.vue?vue&type=template&id=56d07414&scoped=true&"
import script from "./averageDisplayModal.vue?vue&type=script&lang=js&"
export * from "./averageDisplayModal.vue?vue&type=script&lang=js&"
import style0 from "./averageDisplayModal.vue?vue&type=style&index=0&id=56d07414&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d07414",
  null
  
)

export default component.exports